<template>
  <ViewWrapper
    id="confirmed-reservations"
    :title="t('reservations.pageTitle')"
    class="w-100"
  >
    <template v-if="isLoading">
      <ReservationsSkeleton />
    </template>
    <template v-else-if="error">
      <p class="error-message">{{ t('errorMessages.fetchBookings') }}</p>
    </template>
    <template v-else>
      <BookingList :bookings="updatedBookings.currentBookings.value" />
      <PastBookingsList
        :bookings="updatedBookings.pastBookings.value"
        v-if="updatedBookings.pastBookings.value.length"
      />
    </template>
  </ViewWrapper>
</template>

<script setup lang="ts">
  import { useBookings } from '@/composables/useBookings'
  import { useI18n } from 'vue-i18n'

  // VUE Components
  import ReservationsSkeleton from '@/components/ConfirmedReservations/ReservationsSkeleton.vue'
  import ViewWrapper from '@/components/UI/ViewWrapper.vue'
  import BookingList from '@/components/common/BookingList.vue'
  import PastBookingsList from '@/components/ConfirmedReservations/PastBookingsList.vue'
  import { computed, onMounted } from 'vue'
  import store from '@/store'

  // Translations
  const { t } = useI18n()

  // Bookings Map
  const bookingsMap = {
    currentBookings: computed(() => store.getters['booking/currentBookings']),
    pastBookings: computed(() => store.getters['booking/pastBookings']),
  }

  const {
    isLoading,
    error,
    updatedBookings,
    fetchAndMapBookings,
    openPanelByRef,
  } = useBookings(bookingsMap)

  onMounted(async () => {
    await fetchAndMapBookings()
    openPanelByRef()
  })
</script>
